import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImpactDockerComponent } from './comonents/impact-docker/impact-docker.component';
import { RouterModule } from '@angular/router';
import { DonateNowModule } from '../donate-now/donate-now.module';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [ImpactDockerComponent],
  exports: [ImpactDockerComponent],
  imports: [
    CommonModule,
    RouterModule,
    DonateNowModule,
    MatButtonModule
  ]
})
export class ImpactDockerModule { }
